import { ecId, ecLean, definitionNotHeld, handBack, record, type JanusCtx, type Row } from '../ability/context';
import { readItemField } from '../compile/item-field-reader';
import { readLayerListEntryUuid } from '../compile/inventory-raw-readers';
import { readPlayerCharacterField } from '../display/player-character-field';
import { adjustCharges } from '../ability/charges/adjust-charges';
import { isOrdinarySummon, summonControllerId } from './summons';
import { carrierDefinition } from '../ability/statuses/status-trigger-gate';
import { phpJsonTruthy } from '../compile/php-json-values';

/** Native summon-kill reward, using the same held controller and charge writer as triggers. */
export function grantControllerMenace(ctx: JanusCtx, killer: Row, victim: Row): void {
    if (ctx.dryRun || String(readItemField(killer, 'item_type') ?? ecLean(killer, 'item_type')) !== 'creature'
        || !summonControllerId(killer) || isOrdinarySummon(victim)) return;
    const controller = ctx.members.get(summonControllerId(killer));
    if (!controller) handBack('death:menace-controller-not-held');
    let qualifies = false;
    for (const entry of ctx.read.entries(controller, 'passive_ability')) {
        const wrapper = record(entry);
        if (wrapper && Object.prototype.hasOwnProperty.call(wrapper, 'passive_conditions_active')
            && !phpJsonTruthy(readItemField(wrapper, 'passive_conditions_active'))) continue;
        const id = readLayerListEntryUuid(entry), definition = carrierDefinition(ctx, entry, 'death:menace-passive-not-held');
        if (!definition) definitionNotHeld('death:menace-passive-not-held', id);
        if (ctx.read.has(definition, 'summon_trigger_on_kill_grants_caster_menace')) { qualifies = true; break; }
    }
    for (let slot = 1; !qualifies && slot <= 3; slot++) qualifies =
        readPlayerCharacterField(controller, `class_${slot}`) === '2BCE19F7-76A3-EE20-3EA3-C2B8ADA88878'
        && readPlayerCharacterField(controller, `subclass_${slot}`) === '9C4D3940-9EC8-EEFC-C417-1ECBCABE793D';
    if (qualifies) adjustCharges(ctx, controller, 'A8084E61-46B9-FDB5-83CD-59482BA5B8D3', 1, true);
}
